import { Feature } from '@/services/mapbox';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import './index.scss';

export interface InputProps {
  options: Feature[];
  onOptionsChange: (o: Feature[]) => void;
  value: Feature | null;
  onValueChange: (o: Feature | null) => void;
  onInputValueChange: (value: string) => void;
  isError: boolean;
}

export const Input: React.FC<InputProps> = ({
  options,
  onOptionsChange,
  value,
  onValueChange,
  onInputValueChange,
  isError,
}) => (
  <Autocomplete
    getOptionLabel={option => option.place_name || ''}
    isOptionEqualToValue={(option, value) =>
      option.place_name === value.place_name
    }
    filterOptions={x => x}
    options={options}
    autoComplete
    noOptionsText="Inserisci il nome del comune oppure un indirizzo"
    includeInputInList
    filterSelectedOptions
    value={value}
    onChange={(_event, newValue) => {
      onOptionsChange(newValue ? [newValue, ...options] : options);
      onValueChange(newValue);
    }}
    onInputChange={(_event, newInputValue) => {
      onInputValueChange(newInputValue);
    }}
    renderInput={params => (
      <TextField
        {...params}
        label="Inserisci qui un indirizzo"
        variant="standard"
        helperText={
          isError
            ? "IL TUO COMUNE È ATTRAVERSATO DA PIÙ COLLEGI! Inserisci l'indirizzo esatto per scoprire il tuo."
            : ''
        }
        error={isError}
      />
    )}
  />
);
